import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ImageUploading from 'react-images-uploading';
function AddSlider() {


  const [userData, setuserData] = useState({})


  console.log(userData);
  

  const [imagesfe, setImagesfe] = React.useState([]);
  const maxNumberfe = 1;


  const onChangefe = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImagesfe(imageList);
  };


  const [images, setImages] = React.useState([]);
  const maxNumber = 5;

  const onChangeMul = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  console.log(userData);
  const navigate = useNavigate();


  const onChange = (e) => {

    // e

    // e?.target

    // const name = e?.target?.name
    // const value = e?.target?.value

    const {name, value} = e?.target 



    setuserData({ ...userData, [name]: value })
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    console.log(userData);

    try {

      const data2 =  new FormData();
      data2.append('featureImage', imagesfe[0].file);
      data2.append('title', userData.title);
      data2.append('subtitle', userData.subtitle);
      data2.append('buttonText', userData.buttonText);
      data2.append('buttonLink', userData.buttonLink);




    





      const getToken = localStorage.getItem("authToken");
      const response = await fetch("http://localhost:3022/users/createSlider", {
        method: "POST",
        headers: {
          // "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
          Authorization: `Bearer ${getToken}`,
        },
        body: data2, // Body me data send karte hain
        // body: JSON.stringify(userData), // Body me data send karte hain
      });

      const data = await response.json(); // Response ko JSON me convert kare

      if (response.ok) {
        // Login successful
        // setSuccess("Login successful!");
        // alert("Registered Successfully");
        toast?.success(data.message)
        navigate('/slider-list');
        console.log("User data:", data);
      } else {
        console.log("error:");
        // Login failed
        // setError(data.message || "Login failed");
      }
    } catch (err) {
      // setError("Something went wrong. Please try again.");
    }


  }
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', gap: '10px', backgroundColor: 'lightblue', width: '100%', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
      <ImageUploading
        multiple
        value={imagesfe}
        onChange={onChangefe}
        maxNumber={maxNumberfe}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            <button
              style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}
            >
              Click or Drop here
            </button>
            &nbsp;
            <button onClick={onImageRemoveAll}>Remove all images</button>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <button onClick={() => onImageUpdate(index)}>Update</button>
                  <button onClick={() => onImageRemove(index)}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </ImageUploading>
      <input type="text" name='title' onChange={onChange} placeholder='title' />
      <input type="text" name='subtitle' onChange={onChange} placeholder='subtitle' />
      {/* <input type="text" name='featureImage' onChange={onChange} placeholder='featureImage' /> */}
      <input type="text" name='buttonText' onChange={onChange} placeholder='buttonText' />
      <input type="text" name='buttonLink' onChange={onChange} placeholder='buttonLink' />
      {/* <ImageUploading
        multiple
        value={images}
        onChange={onChangeMul}
        maxNumber={maxNumber}
        dataURLKey="data_url"
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div className="upload__image-wrapper">
            <button
              style={isDragging ? { color: 'red' } : undefined}
              onClick={onImageUpload}
              {...dragProps}
            >
              Click or Drop here
            </button>
            &nbsp;
            <button onClick={onImageRemoveAll}>Remove all images</button>
            {imageList.map((image, index) => (
              <div key={index} className="image-item">
                <img src={image['data_url']} alt="" width="100" />
                <div className="image-item__btn-wrapper">
                  <button onClick={() => onImageUpdate(index)}>Update</button>
                  <button onClick={() => onImageRemove(index)}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </ImageUploading> */}

      <button onClick={(e) => onSubmit(e)}>Submit</button>
    </div>
  )
}

export default AddSlider
